import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import TranslatedPage from "../containers/TranslatedPage/TranslatedPage";
import Footer from "../containers/Footer";
import CustomIcon from "../components/CustomIcon";
import Image from "../components/Image";
import AppWrapper from "../containers/AppWrapper";

class AboutUs extends Component {
  render() {
    return (
      <AppWrapper>
        <TopNav />

        <section className="gray-bg">
          <div className="main-container">
            <div className="content-wrapper">
              <div className="about-us-detailed">
                <div className="item">
                  <div className="heading">
                    <CustomIcon name="grow-outline" className="icon" size="64" />
                    <h1 className="hero-heading about-us">
                      <TranslatedPage path="about-us.content_blocks.about_us_the_seed.heading" />
                    </h1>
                  </div>
                  <div className="copy">
                    <p>
                      <TranslatedPage path="about-us.content_blocks.about_us_the_seed.content" />
                    </p>
                  </div>
                </div>

                <div className="item">
                  <div className="heading">
                    <CustomIcon name="vision-outline" className="icon" size="64" />
                    <h1 className="hero-heading about-us">
                      <TranslatedPage path="about-us.content_blocks.about_us_the_vision.heading" />
                    </h1>
                  </div>
                  <div className="copy">
                    <p>
                      <TranslatedPage path="about-us.content_blocks.about_us_the_vision.content" />
                    </p>
                  </div>
                </div>

                <div className="item team">
                  <div className="heading">
                    <CustomIcon name="connect-outline" className="icon" size="64" />
                    <h1 className="hero-heading about-us">
                      <TranslatedPage path="about-us.content_blocks.about_us_the_team.heading" />
                    </h1>
                  </div>
                  <div className="copy">
                    <p>
                      <TranslatedPage path="about-us.content_blocks.about_us_the_team.content" />
                    </p>
                    <Image src={require("../styles/images/coneeds-team.jpg")} alt="ihopa Team" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </AppWrapper>
    );
  }
}

export default AboutUs;
